import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { FileDown, FileText, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CustomerReports = () => {
  const [reports, setReports] = useState(null);
  const [downloading, setDownloading] = useState(null);

  useEffect(() => {
    axios.get(`${API}/me/reports`, { withCredentials: true })
      .then((r) => setReports(r.data.reports))
      .catch(() => setReports([]));
  }, []);

  const download = async (r) => {
    setDownloading(r.id);
    try {
      const res = await axios.get(`${API}/reports/${r.id}/download`, {
        withCredentials: true,
        responseType: "blob",
      });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = r.original_filename || "report.pdf";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Download failed. Please try again.");
    } finally {
      setDownloading(null);
    }
  };

  return (
    <div className="rounded-3xl border border-white/15 bg-[#0F1B31]/80 p-8" data-testid="customer-reports-section">
      <p className="font-mono-label text-xs uppercase tracking-[0.3em] text-slate-400 mb-6 flex items-center gap-2">
        <FileText className="h-4 w-4" /> Your Monthly Reports
      </p>
      {reports === null ? (
        <Loader2 className="h-5 w-5 animate-spin text-slate-500" />
      ) : reports.length === 0 ? (
        <p className="text-sm text-slate-500" data-testid="customer-reports-empty">
          No reports yet — your first monthly audit report will appear here.
        </p>
      ) : (
        <div className="space-y-2" data-testid="customer-reports-list">
          {reports.map((r) => (
            <div key={r.id} className="flex items-center justify-between gap-4 rounded-xl border border-white/10 px-4 py-3" data-testid={`customer-report-${r.id}`}>
              <div className="min-w-0">
                <p className="text-sm text-slate-200 truncate">{r.title}</p>
                <p className="text-xs text-slate-500">{new Date(r.created_at).toLocaleDateString()}</p>
              </div>
              <button
                onClick={() => download(r)}
                disabled={downloading === r.id}
                data-testid={`customer-report-download-${r.id}`}
                className="inline-flex shrink-0 items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm text-slate-300 transition-colors duration-300 hover:bg-white hover:text-[#060D1A] disabled:opacity-50"
              >
                {downloading === r.id ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileDown className="h-4 w-4" />}
                Download
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
